import { FC, useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import useStyles from "../Styles/ProjectModalStyles";
import Lottie from "lottie-react";
import DisconnectAnimation from '../../assets/animations/Disconnect.json';

type SwitchWalletModalProps = {
  open: boolean;
  setOpen: (state: boolean) => void;
  whitelistedAddress: string;
};

const SwitchWalletModal: FC<SwitchWalletModalProps> = ({
  open,
  setOpen,
  whitelistedAddress,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const isActive = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages}`}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            <Box mb={2} p={0} justifyContent="center" style={{ display: "flex", margin: "20px 0px 20px 0px" }}>
                <Lottie animationData={DisconnectAnimation} style={{
                    width: "196px",
                    height: "auto",
                }} />
            </Box>
            <Box mb={2} p={0} justifyContent="center" textAlign="center">
              <Typography variant="h2" color="primary">
                Wrong Address Connected
              </Typography>{" "}
            </Box>

            <Box mt={2} justifyContent="center" textAlign="center">
              <Typography
                variant="caption"
                className="text-darkslate warning-text "
              >
                Please select the following address on your wallet
              </Typography>
              <Typography
                variant="subtitle1"
              >
                {whitelistedAddress}
              </Typography>
            </Box>

            <Box display="flex" mt={isActive ? 3 : 5} justifyContent="center">
              <Box mr={isActive ? 0 : 1} flexGrow={isActive ? 1 : 0}>
                <Button
                  variant="contained"
                  className={`contribute-btn`}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default SwitchWalletModal;
